import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { updateFamily } from '../../../../services/clinicPortalServices/familyService';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import toastr from 'toastr';

export default class EditFamily extends Component {
    constructor(props) {
        super(props);
        this.state = {
            familyName: '',
            errors: [],
            saving: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && this.props.show !== prevProps.show) {
            this.setState({
                familyName: this.props.data.family_name
            });
        }
    }

    hasError = (key) => {
        return this.state.errors.indexOf(key) !== -1;
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        if (this.state.errors.includes(e.target.name) && e.target.value) {
            const errors = this.state.errors.filter((error) => error !== e.target.name);
            this.setState({ errors });
        }
    };

    handleClose = () => {
        this.props.handleClose();
        this.setState({
            familyName: '',
            errors: [],
            saving: false
        });
    };

    handleSave = () => {
        const errors = [];
        if (!this.state.familyName) {
            errors.push('familyName');
        }

        if (errors.length) {
            this.setState({ errors });
            return;
        }

        this.setState({ saving: true });
        updateFamily({
            _id: this.props.data._id,
            family_name: this.state.familyName
        })
            .then((response) => {
                this.setState({ saving: false });
                this.handleClose();
                this.props.loadGridData();
                toastr.success('Family updated successfully.');
            })
            .catch(() => {
                this.setState({ saving: false });
            });
    };

    render() {
        return (
            <ModalStyled
                size="lg"
                centered
                show={this.props.show}
                onHide={this.handleClose}
                backdrop="static"
                dialogClassName="removeTabIndexModal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Family</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>Family ID</label>
                        <input type="text" className="form-control" value={this.props.data?.family_id || ''} disabled />
                    </div>
                    <div className="form-group">
                        <label>
                            Family Name <abbr className="text-danger">*</abbr>
                        </label>
                        <input
                            type="text"
                            name="familyName"
                            value={this.state.familyName}
                            onChange={this.handleChange}
                            className={this.hasError('familyName') ? 'form-control is-invalid' : 'form-control'}
                        />
                        <div className={this.hasError('familyName') ? 'inline-errormsg' : 'hidden'}>
                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                &nbsp;This field is required.
                            </i>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={this.handleSave}>
                        {this.state.saving && <i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }}></i>}
                        Save Changes
                    </Button>
                </Modal.Footer>
            </ModalStyled>
        );
    }
}